import { useTranslation } from 'next-i18next'

// Components
import SettingUserNamePopupContentForm from './SettingUserNamePopupContentForm'
import SettingUserNamePopupContentFormik from './SettingUserNamePopupContentFormik'

const SettingUserNamePopupContent = (props: any) => {
  const { setUsername, closeSettingUsernamePopup } = props

  const { t } = useTranslation()

  return (
    <SettingUserNamePopupContentFormik {...props} t={t} setUsername={setUsername} closeSettingUsernamePopup={closeSettingUsernamePopup}>
      <SettingUserNamePopupContentForm {...props} />
    </SettingUserNamePopupContentFormik>
  )
}

export default SettingUserNamePopupContent
